import { z } from 'zod'

/** Parâmetros de URL comuns às listagens (`validateSearch` das rotas). Valores inválidos viram `undefined`. */
export const pageSearch = z.number().int().positive().optional().catch(undefined)
export const textSearch = z.string().optional().catch(undefined)
